import { memo, ReactElement } from 'react';
import { DataGridPro, DataGridProProps } from '@mui/x-data-grid-pro';
import { BaseColumnModel } from '../types/paginated-table';

const hasId = (model: BaseColumnModel): model is { id: string | number } => {
  return 'id' in model;
};

const getModelId = (model: BaseColumnModel) => {
  return hasId(model) ? model.id : model.getId();
};

export const MemoizedMuiDataGrid = memo(
  <T extends BaseColumnModel>(props: DataGridProProps<T>) => <DataGridPro<T> {...props} />,
  (prevProps, nextProps) => {
    if (prevProps.rows.length !== nextProps.rows.length) {
      return false;
    }
    if (prevProps.nonce !== nextProps.nonce) {
      return false;
    }

    const compareFn = nextProps.getRowId ?? getModelId;

    return prevProps.rows.every((prevRow, index) => {
      const nextRow = nextProps.rows[index];
      return compareFn(prevRow) === compareFn(nextRow);
    });
  }
) as (props: DataGridProProps) => ReactElement;
